<fr-table Id="exported-files-table" [config]="tableConfig" [paginatorConfig]="paginatorConfig"
  [data]="sessionData?.json?.output">
</fr-table>
<div class="table-sub-header">
  <app-loading-spinner *ngIf="!sessionData"></app-loading-spinner>
</div>